<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
        <div class="w-100">
			<select 
			class="form-control"
			style="border-radius: 10px;"
			@change="(e)=>{select_search(e)}"
			>
				<option value="all">همه</option>
				<option v-for="(f, i) in select_fld" :key="i">
					{{ f }}
				</option>
			  </select>
			  <hr>
			  <div class="row">
				<div class="col-6">
				<b>
					فهرست تیکت ها
				</b>
				</div>
				<div class="col-6">
					<router-link to="/ticket/create">
						<btn 
						class="d-flex justify-content-end"
						textClass="p-2"
						style_btn=""
						text="+ تیکت جدید"
						/>
					</router-link>
				</div>
			  </div>
			<table class="table mt-3" 
			v-for="(f, i) in flds.data.content" :key="i"
			v-if="f.subject==select_search_val || select_search_val=='all'"
			:style="(f.read_user==1) ? 'background-image: url('+require('../../assets/img/circle.svg')+');': ''"
				style="background-repeat: no-repeat;
				background-position: 98% 2%;"
			>
				<tr>
					<th>عنوان تیکت</th>
					<td>{{ f.subject }}</td>
				</tr>
				<tr>
					<th>کارشناس پشتیبانی</th>
					<td>{{ f.crm }}</td>
				</tr>
				<tr>
					<th>دپارتمان</th>
					<td>{{ f.field }}</td>
				</tr>
				<tr>
					<th>تاریخ ایجاد</th>
					<td>{{ f.date_start }}</td>
				</tr>
				<tr>
					<th>شماره تیکت</th>
					<td>{{ f.code }}</td>
				</tr>
				<tr>
					<th>شماره تیکت</th>
					<td>{{ f.date_end }}</td>
				</tr>
				<tr>
					<th>وضعیت تیکت</th>
					<td :style="'color:'+read_crm[f.read_crm].color">{{ read_crm[f.read_crm].name }}</td>
				</tr>
				<tr>
					<td colspan="2">
						<router-link :to="'/ticket/'+f.id">
							<btn 
							textClass="w-100"
							style_btn="padding:5px !important;"
							text="مشاهده"
							/>
						</router-link>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

	<script>
	import btn from  "../../UI/button/btn.vue";
	import * as read_crm_json from  "./read_crm.json";
	
		export default {
			name: 'part1_empty',
			data(){
				return {
					select_fld: [],
					select_search_val: 'all',
					read_crm: read_crm_json.default
				}
			},
			components: {
				btn,
			},
			props: ["flds"],
			mounted(){
                for (let i = 0; i < this.flds.data.length; i++) {
					if (!this.select_fld.includes(this.flds.data[i].subject)) {
						this.select_fld.push(this.flds.data[i].subject);
					}
				}
			},
			methods:{
				select_search(e){
					this.select_search_val = e.target.value;
				}
			}
		}
	</script>
<style scoped>
.table thead th, table th {
	background-color: unset;
	color: #1b60c6;
	font-size: 12px;
}
td{
	border-radius: 8px;
	font-size: 12px;
	color: #676767;
	border: none;
}
table:nth-child(odd){
	background-color:#fff;
}
table:nth-child(even){
	background-color: #F5FAFD;
}
</style>
